import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Form = styled.div`
  margin-top: 10px;

  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
  }
`

export const Label = styled.div`
  margin-bottom: 8px;

  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #FFFFFF;
`

export const Textarea = styled.textarea`
  width: 70%;
  height: 150px;
  padding: 11px 8px;

  font-size: 14px;
  line-height: 21px;
  color: #333;
  background: #F2F2F2;
  border: 1px solid #828282;
  box-sizing: border-box;
  border-radius: 8px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
    height: 150px;
  }
`
export const AiAlert = styled.div<any>`
  display: flex;
  border-radius: 15px;
  width: 70%;
  justify-content: start;
  padding: 10px 0;
  align-items: start;
  ${(props) => props.strong && ('font-weight: 700;')}

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
  }

`
